import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';




const Feedback = () => {
  return (
    <div> 
         <section className='bg-[#ECF2FE] pb-10'> 
       <div className='container mx-auto'>
        <div className='text-center pt-10'> 
             <h1 className='font-semibold mt-4'> Feedback <span className='border-b-2  border-[#FFFFFF]'>from </span>our  users </h1>
            
        </div>
       

        
        <div className='w-full lg:w-1/2 mx-auto mt-4'> 
              <Splide options={ { perPage:1, page:1,  autoplay:true, rewind:true, pagination:false,
              } }>
            <SplideSlide>
                <div className=' pt-4 rounded-md  w-11/12 pb-4 sm:w-3/4 md:w-8/12  bg-[#ffffff] mx-auto flex justify-between px-6'> 
                  <img className='h-4' src='./image/comment.png' alt=''/>
                    <div className='flex flex-col '> 
                      <p className='ml-1  h-26 md:h-20 text-xs md:text-sm lg:text-xs md:w-11/12 text-textgray sm:text-base '> The experience has been pleasant, professional and exceeding our expectations. The team is always thinking beyond. </p>
                      <h1 className='mt-2 ml-1 font-bold'> Helen elan </h1>
                     
                    </div>
                     <img className='h-10 ml-2' src='./image/lady.png' alt=''/>



                </div>
            </SplideSlide>


             <SplideSlide>
                <div className=' pt-4 rounded-md  w-11/12 pb-4  sm:w-3/4 md:w-8/12  bg-[#ffffff] mx-auto flex justify-between px-6'> 
                  <img className='h-4' src='./image/comment.png' alt=''/>
                    <div className='flex flex-col md:w-11/12 '> 
                      <p className='ml-1  h-26 md:h-20 lg:text-xs text-xs md:text-sm sm:text-base text-textgray'> i love and enjoyed using ms lock down. meeting new friends is fun. </p>
                      <h1 className='mt-2 ml-1 font-bold'> paul jlin </h1>
                     
                    </div>
                     <img className='h-10 ml-2' src='./image/lady.png' alt=''/>



                </div>
            </SplideSlide>



          </Splide>

    </div>
        
    </div>
   </section>

   


    </div>

  )
}

export default Feedback